import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { LocationInfo } from '../../../../modules/LocationInfo/layout/LocationInfo.js';

const PickupLocationInformation = ({ title , location , onPickupModalShow , hideTitle =false  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, !hideTitle && /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: "checkout-step__title"
    }, title), /*#__PURE__*/ React.createElement(LocationInfo, {
        location: location,
        onEdit: onPickupModalShow
    }))
;

export { PickupLocationInformation };
//# sourceMappingURL=PickupLocationInformation.js.map
